/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import cx from 'classnames';
import { Icon } from 'semantic-ui-react';
import dragbarImg from '../../images/components/my/drager.svg';

class BookmarkItem extends Component {
  constructor(props) {
    super(props);
    this.handleViewPointChange = this.handleViewPointChange.bind(this);
    this.handleRemoveBookmark = this.handleRemoveBookmark.bind(this);
    this.handleChangeView = this.handleChangeView.bind(this);
  }

  componentDidMount() {
    if (localStorage.getItem('bookmarkObj')) {
      localStorage.removeItem('bookmarkObj');
    }
  }

  handleViewPointChange = (e) => {
    const { handleViewPointChange, item } = this.props;
    handleViewPointChange(item.id, e.currentTarget.dataset.id);
  };

  handleRemoveBookmark = () => {
    const { item, handleRemoveBookmark } = this.props;
    const { name, id } = item;
    const obj = {
      name,
      id,
    };
    handleRemoveBookmark(obj);
  };

  handleChangeView = (e) => {
    const { item, handleChangeView } = this.props;
    const {
      targetObject, targetId, viewPoint, extraData, name
    } = item;
    const obj = {
      targetObject,
      targetId,
      viewPoint,
      name,
      projectName: extraData.project || null,
      type: e.currentTarget.dataset.id,
    };
    handleChangeView(obj);
  };

  render() {
    const getItemStyle = (isDragging, draggableStyle) => {
      return {
        userSelect: 'none',
        background: isDragging ? '#fae7ff' : 'rgba(255, 255, 255, 0.8)',
        ...draggableStyle,
      };
    };
    const {
      translate, draggableProvided, draggableSnapshot, item
    } = this.props;

    return (
      <div
        className="my_bookmarks_item"
        ref={draggableProvided.innerRef}
        {...draggableProvided.draggableProps}
        {...draggableProvided.dragHandleProps}
        style={getItemStyle(
          draggableSnapshot.isDragging,
          draggableProvided.draggableProps.style
        )}
      >
        <table
          className={cx('my_bookmarks_item_table', {
            new_data: item.isNewlyAdded,
          })}
        >
          <colgroup>
            <col style={{ width: '4.3%', maxWidth: '52px' }} />
            <col style={{ width: '29%', maxWidth: '350px' }} />
            <col style={{ width: '66%', maxWidth: '800px' }} />
          </colgroup>
          <tbody>
            <tr>
              <td
                className="left_td"
              >
                <a
                  className="drager_button"
                >
                  <img src={dragbarImg} alt="" />
                </a>
              </td>
              <td style={{ verticalAlign: 'middle', textAlign: 'left' }}>
                {item.targetObject === 'report' && (
                  <div className="info">
                    <a className="name">
                      <span data-id="current" onClick={this.handleChangeView} onKeyUp={this.handleChangeView}>
                        {item.name}
                      </span>
                    </a>
                    <p className="project_name">
                      {`${item.extraData.project} /
                        ${item.extraData.project_version}`}
                    </p>
                  </div>
                )}
                {item.targetObject === 'project_version' && (
                  <div className="info">
                    <a className="name">
                      <span
                        data-id="current"
                        onClick={this.handleChangeView}
                        onKeyUp={this.handleChangeView}
                      >
                        {`${item.extraData.project} / ${item.name}`}

                      </span>
                    </a>
                  </div>
                )}
                {item.targetObject === 'project' && (
                  <div className="info">
                    <a className="name">
                      <span data-id="current" onClick={this.handleChangeView} onKeyUp={this.handleChangeView}>
                        {item.name}
                      </span>
                    </a>
                  </div>
                )}
              </td>
              <td className="right_td">
                {item.isOverviewAllowed ? (
                  <span
                    className={cx('label is_clickable', {
                      active: item.viewPoint.indexOf('overview') > -1,
                    })}
                    data-id="overview"
                    onClick={this.handleViewPointChange}
                    onKeyUp={this.handleViewPointChange}
                  >
                    {translate('my_page.title.overview')}
                  </span>
                ) : (
                  <span
                    className={cx('label is_disable', {
                      active: item.viewPoint.indexOf('overview') > -1,
                    })}
                  >
                    {translate('my_page.title.overview')}
                  </span>
                )}
                {item.isComponentAllowed ? (
                  <span
                    className={cx('label is_clickable', {
                      active: item.viewPoint.indexOf('component') > -1,
                    })}
                    data-id="component"
                    onClick={this.handleViewPointChange}
                    onKeyUp={this.handleViewPointChange}
                  >
                    {translate('my_page.title.component')}
                  </span>
                ) : (
                  <span
                    className={cx('label is_disable', {
                      active: item.viewPoint.indexOf('component') > -1,
                    })}
                  >
                    {translate('my_page.title.component')}
                  </span>
                )}
                {item.isSecurityAllowed ? (
                  <span
                    className={cx('label is_clickable', {
                      active: item.viewPoint.indexOf('security') > -1,
                    })}
                    data-id="security"
                    onClick={this.handleViewPointChange}
                    onKeyUp={this.handleViewPointChange}
                  >
                    {translate('my_page.title.security_risks')}
                  </span>
                ) : (
                  <span
                    className={cx('label is_disable', {
                      active: item.viewPoint.indexOf('security') > -1,
                    })}
                  >
                    {translate('my_page.title.security_risks')}
                  </span>
                )}
                {item.isLicenseAllowed ? (
                  <span
                    className={cx('label is_clickable', {
                      active: item.viewPoint.indexOf('license') > -1,
                    })}
                    data-id="license"
                    onClick={this.handleViewPointChange}
                    onKeyUp={this.handleViewPointChange}
                  >
                    {translate('my_page.title.licenses')}
                  </span>
                ) : (
                  <span
                    className={cx('label is_disable', {
                      active: item.viewPoint.indexOf('license') > -1,
                    })}
                  >
                    {translate('my_page.title.licenses')}
                  </span>
                )}
                {item.isPolicyAllowed ? (
                  <span
                    className={cx('label is_clickable', {
                      active: item.viewPoint.indexOf('policy') > -1,
                    })}
                    data-id="policy"
                    onClick={this.handleViewPointChange}
                    onKeyUp={this.handleViewPointChange}
                  >
                    {translate('my_page.title.policy')}
                  </span>
                ) : (
                  <span
                    className={cx('label is_disable', {
                      active: item.viewPoint.indexOf('policy') > -1,
                    })}
                  >
                    {translate('my_page.title.policy')}
                  </span>
                )}
                <div className="button_wrap">
                  <a className="button" data-id="window" onClick={this.handleChangeView} onKeyUp={this.handleChangeView}>
                    <Icon
                      name="external alternate"
                      color="grey"
                      style={{ fontSize: '15px', cursor: 'pointer' }}
                    />
                  </a>
                  <a className="button delete_button" onClick={this.handleRemoveBookmark} onKeyUp={this.handleRemoveBookmark}>
                    <Icon
                      name="cancel"
                      style={{ fontSize: '15px', color: '#ff3a6c', cursor: 'pointer' }}
                    />
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
export default BookmarkItem;
